import { TagTypeForm } from "./TagTypeForm";

export const TagTypeCreate = () => {
    return <TagTypeForm mode="create" />;
};
